"use client";
import { useState } from "react";
import { IoTrashOutline } from "react-icons/io5"; // Importa el ícono de cerrar

export const SearchODS = ({ data, handleOnChange }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
    setIsDropdownVisible(true);
  };

  const handleItemClick = ({ index, label }) => {
    setSearchTerm(label);
    handleOnChange(index); // "" activa el modo 'Todos'
    setIsDropdownVisible(false);
  };

  const clearInput = () => {
    setSearchTerm("");
    setIsDropdownVisible(false);
    handleOnChange(""); // Esto selecciona 'Todos' también
  };
  const normalizeText = (text) => {
    return text
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };
  const searchFilteredData = searchTerm.trim()
    ? [
        { index: "", label: "Todos" },
        ...data.filter((item) =>
          normalizeText(item.label).includes(normalizeText(searchTerm))
        ),
      ]
    : [{ index: "", label: "Todos" }, ...data]; // Cuando vacío también incluir "Todos"

  return (
    <>
      <div className="w-full md:w-4/12 relative">
        <input
          type="text"
          placeholder="Buscar por ODS..."
          value={searchTerm}
          onChange={handleInputChange}
          onFocus={() => setIsDropdownVisible(true)} // Mostrar al enfocar
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 mb-4"
        />

        {searchTerm && (
          <IoTrashOutline
            className="absolute right-3 top-3 text-gray-500 text-xl cursor-pointer"
            onClick={clearInput}
          />
        )}
        {searchTerm.length > 0 && isDropdownVisible && (
          <ul className="divide-y divide-gray-200 bg-white shadow-lg p-4 max-h-60 absolute z-50 w-full left-0 top-full mt-2 overflow-y-auto rounded-lg">
            {searchFilteredData.length > 0 ? (
              searchFilteredData.map((item) => (
                <li
                  key={item.index}
                  className="py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleItemClick(item)} // Al hacer clic, seleccionamos el valor y ocultamos el desplegable
                >
                  {item.label}
                </li>
              ))
            ) : (
              <li className="py-2 text-red-500">
                No se encontraron resultados
              </li>
            )}
          </ul>
        )}
      </div>
    </>
  );
};
